<template>
  <b-input-group class="group-phones">
    <slot />
    <b-form-input
      class="mt-1"
      v-model="phone_value"
      @keypress="phoneNumber($event)"
      :state="validateState('value')"
    ></b-form-input>

    <b-input-group-append class="mt-1">
      <b-form-checkbox
        v-model="phone.whatsapp"
        class="social-button whatsapp-icon"
        button
      />

      <b-form-checkbox
        v-model="phone.telegram"
        class="social-button telegram-icon"
        :class="{ 'checked-icon': phone.telegram }"
        button
      />

      <b-button
        v-b-tooltip.hover
        title="Remover número"
        variant="danger"
        @click="remove()"
      >
        <font-awesome-icon icon="trash" />
      </b-button>
    </b-input-group-append>

    <b-form-invalid-feedback>
      <span v-if="!$v.phone.value.numeric">Telefone inválido</span>
      <span v-if="!$v.phone.value.minLength"
        >Telefone deve ter no mínimo 10 caracteres</span
      >
      <span v-if="!$v.phone.value.maxLength"
        >Telefone deve ter no máximo 11 caracteres</span
      >
    </b-form-invalid-feedback>
  </b-input-group>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/esm/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/esm/mixins/form-state";

import { sortKeys } from "bootstrap-vue/esm/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/esm/utils/props";

import { validationMixin } from "vuelidate";
import { numeric, minLength, maxLength } from "vuelidate/lib/validators";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {},
  })
);

export default {
  mixins: [formControlMixin, formStateMixin, validationMixin],
  props,
  data: () => ({
    phone: {},
  }),
  computed: {
    phone_value: {
      set(value) {
        this.phone.value = value.replace(/\D/g, "").substring(0, 11);
      },
      get() {
        let value = this.phone.value;

        if (value.length == 11) {
          value = value.replace(/^(\d{2})(\d{1})(\d{4})(\d)/, "($1) $2 $3-$4");
        } else {
          value = value.replace(/^(\d{2})(\d{4})(\d)/, "($1) $2-$3");
        }

        return value;
      },
    },
  },
  validations: {
    phone: {
      value: {
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(11),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.phone[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.phone.$touch();
      return !this.$v.phone.$anyError;
    },
    remove() {
      this.$emit("remove");
    },
    phoneNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  watch: {
    value: function (value) {
      this.phone = value;
    },
  },
  created() {
    this.phone = this.value;
  },
};
</script>

<style>
</style>
